import { PermissionSet, UserSelf } from 'shared/models';

//
//  Action Constants
//

export const Actions = {
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',

    LOGOUT_REQUEST: 'LOGOUT_REQUEST',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    LOGOUT_FAILURE: 'LOGOUT_FAILURE',
};


//
//  Action Creators
//

// This is now only used for an automatic login based on a pre-existing session cookie
export const loginRequest = (payload: { callback(): void }) => ({
    type: Actions.LOGIN_REQUEST,
    payload,
});
export const loginSuccess = (payload: { user: UserSelf; permissions: PermissionSet }) => ({
    type: Actions.LOGIN_SUCCESS,
    payload,
});
export const loginFailure = (err: Error) => ({
    type: Actions.LOGIN_FAILURE,
    error: true,
    payload: err,
});

export const logoutRequest = () => ({
    type: Actions.LOGOUT_REQUEST,
});
export const logoutSuccess = () => ({
    type: Actions.LOGOUT_SUCCESS,
});
export const logoutFailure = (err: Error) => ({
    type: Actions.LOGOUT_FAILURE,
    error: true,
    payload: err,
});
